import { LhStorageService } from '@hssa-itasia/ngx-util-core';
import { AppService } from 'src/app/app.service';
import {
  Component,
  ViewChild,
  ViewEncapsulation,
  NgZone,
  Renderer2,
  ChangeDetectorRef,
  effect,
  inject,
  DestroyRef
} from '@angular/core';
import { ActivatedRoute, ActivationEnd, NavigationEnd } from '@angular/router';
import { DomController, IonFab, ModalController, Platform } from '@ionic/angular';
import { delay, distinctUntilChanged, first, map, mergeMap, take, withLatestFrom } from 'rxjs/operators';
import { filter } from 'rxjs/operators';
import { LangChangeEvent } from '@ngx-translate/core';
import { v4 as uuidv4 } from 'uuid';
import { fetchAndActivate, getValue, RemoteConfig } from '@angular/fire/remote-config';
import { App, AppState } from '@capacitor/app';
import { StatusBar, Style } from '@capacitor/status-bar';
import { TranslateService } from '@ngx-translate/core';
import { Location } from '@angular/common';
import { Subject, Subscriber, firstValueFrom, lastValueFrom, from, BehaviorSubject, interval } from 'rxjs';
import { Geolocation } from '@capacitor/geolocation';
import { Subscription, timer } from 'rxjs';
import { RapidtourService } from 'src/app/services/rapid-tour/rapidtour.service';
import { BogTourService } from 'src/app/services/bog-tour/bog-tour.service';
import { Device } from '@capacitor/device';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { Keyboard } from '@capacitor/keyboard';
import { JailbreakRoot } from '@basecom-gmbh/capacitor-jailbreak-root-detection';
import { register } from 'swiper/element/bundle';
import { ControllerOptionsComponent } from 'src/app/components/controller-options/controller-options.component';
import { Capacitor, PluginListenerHandle } from '@capacitor/core';
import { where } from '@angular/fire/firestore';
import { Auth, authState } from '@angular/fire/auth';
import { PushNotifications } from '@capacitor/push-notifications';
import { AndroidSettings, IOSSettings, NativeSettings } from 'capacitor-native-settings';
import { Events } from './services/event-service/event-service.service';
import { AreaManagementService } from './services/area-management/area-management.service';
import { TreasurehuntService } from './services/treasureHunt/treasurehunt.service';
import { QrModeComponent } from './components/qr-mode/qr-mode.component';
import { MorePage } from './pages/more/more.page';
import { SendEmailModalPage } from './pages/send-email-modal/send-email-modal.page';
import { VpcHazService } from './pages/vpc-haz/vpc-haz.service';

// Configure pdfMake with fonts
// Handle different import structures and environments
try {
//  console.log('pdfMake:', pdfMake);
//  console.log('pdfFonts:', pdfFonts);

  // Use Object.assign to set vfs property
  if (pdfFonts && pdfFonts.pdfMake && pdfFonts.pdfMake.vfs) {
    Object.assign(pdfMake, { vfs: pdfFonts.pdfMake.vfs });
   // console.log('pdfMake.vfs configured with pdfFonts.pdfMake.vfs');
  } else if (pdfFonts && pdfFonts.vfs) {
    Object.assign(pdfMake, { vfs: pdfFonts.vfs });
  //  console.log('pdfMake.vfs configured with pdfFonts.vfs');
  } else if (pdfFonts) {
    // Try alternative structure where pdfFonts is the vfs directly
    Object.assign(pdfMake, { vfs: pdfFonts });
//    console.log('pdfMake.vfs configured with pdfFonts directly');
  } else if (typeof globalThis !== 'undefined' && globalThis.pdfMake && globalThis.pdfMake.vfs) {
    // Fallback to global pdfMake vfs
    Object.assign(pdfMake, { vfs: globalThis.pdfMake.vfs });
  //  console.log('pdfMake.vfs configured with globalThis.pdfMake.vfs');
  } else {
  //  console.warn('pdfFonts not available, PDF generation may not work properly');
    // Create empty vfs to prevent errors
    Object.assign(pdfMake, { vfs: {} });
  //  console.log('pdfMake.vfs set to empty object');
  }
} catch (error) {
//  console.error('Error configuring pdfMake vfs:', error);
  // Create empty vfs to prevent errors
  Object.assign(pdfMake, { vfs: {} });
//  console.log('pdfMake.vfs set to empty object due to error');
}

import { AIService } from './services/ai-service/ai-services';
import { leagueChatService } from './pages/treasure_hunt/TH_chat/league-chat.service';
import { LeagueService } from './services/league/league.service';
import { AudioService } from './services/audio/audio.service';
import { StepCounterService } from './services/stepcounter/step-counter.service';
import { TenantService } from './services/tenant/tenant.service';
import { BackButtonService } from './services/back-button/back-button.service';
import { PushNotificationService } from './services/push-notification/push-notification.service';
import { AuthService } from './services/auth-service/auth-service';
import { BaseInjectorService } from './base/base-service.injector';
import { environment } from '../environments/environment';
// import { FirebaseCrashlytics } from '@ionic-native/firebase-crashlytics/ngx';
// import { FirebaseCrashlytics } from '@capacitor-community/firebase-crashlytics';

//// its a part of 3.5.6 release
// import {SpeechRecognition } from '@capacitor-community/speech-recognition';
// import {TextToSpeech } from '@capacitor-community/text-to-speech';
// import { PushNotifications } from '@capacitor/push-notifications';
// import { AndroidSettings, IOSSettings, NativeSettings } from 'capacitor-native-settings';
import { MessageActionModalComponent } from './components/common/message-action-modal/message-action-modal.component';
import { ThMessageModalComponent } from './components/treasure-hunt/th-message-modal/th-message-modal.component';
import { ThAnnouncementModalComponent } from './components/treasure-hunt/th-announcement-modal/th-announcement-modal.component';
import { PerformanceService } from './services/performance/performance.service';
import { AppInfoService } from './services/app/app-info/app-info.service';
import { BogTourModalComponent } from './components/bog_tour/bog-tour-modal/bog-tour-modal.component';
import { ShieldOnBoardingSlidesComponent } from './pages/shield/shield-onboard/shield-on-boarding-slides/shield-on-boarding-slides.component';
import { EdgeToEdge } from '@capawesome/capacitor-android-edge-to-edge-support';
register();
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class AppComponent extends BaseInjectorService {
  @ViewChild('fab') fab: IonFab;
  menuList: any;
  menuDir: any;
  versionNumber: any;
  greet: any;
  forceUpdateSubscription: any;
  textDir: any;
  policyMenu: any;
  showTabs = false;
  showBubble = false;
  replaceLeftTabsWtBtn: boolean | any = false;
  replaceRightTabsWtBtn: boolean | any = false;
  isTreasureHuntEnabled: boolean = false;
  currentSiteData: any;
  overdueActionCount: any = 0;
  total_open_action: number;
  data: Promise<any>;
  // bogTourButtonStatus: string = "TOUR_NOT_STARTED";
  bogTourButtonStatus: string = '';
  tourStatus: boolean = false;
  rapidOpt: boolean = false;
  tripTimer: any;
  appExitPopupShow: boolean = false;
  torchOnOff: boolean = true;
  QRbackbuttonSubscription: any;
  bogTourTripSubscriber: Subscription;
  delete_count = 0;
  email_count = 0;
  changeTabBg: boolean;
  currentPage: any = '';
  bottomPadding: any = '0px';
  marginBottom: any = '44px';
  lastVisitedPage: any;
  areaOpt: boolean = false;
  qrCodeList: any = [];
  generatedPDFS: any = [];
  area_managent_selectedData: any = {};
  ratingOpt: boolean = false;
  isMoreButton: boolean = false;
  isAreaOwner: boolean = false;
  isShowoldButton: boolean = true;
  isMoreButtonOpen: boolean = false;
  isareaOwner: boolean = false;
  isKeyboardOpen: boolean = false;
  tour_end_option_text: string = '';
  abortBtnFlag: boolean = false;
  userDataOnLogin: any;
  firstTimeLogin: boolean = false;
  loginUserData: any;
  translatedefault = {
    CONTROLLER_START: 'Start',
  };
  langSynced: boolean = false;
  isControllerOptionOpen: boolean = false;
  app_footer_TAB_theme: string = '';
  speed;
  network: any = { effectiveType: '' };
  skipUpdateCount: any;
  lastUpdateTime: Date;
  lastPopUpTime: number;
  is_obs_screen: boolean = false;
  // stepCountServcie: any;
  showCompassIcon: boolean = false;
  transcript: string = ''; // To store the final transcript
  isListening: boolean = false; // State to manage listening status
  available: { available: boolean };
  myText: any;
  currentTour: any;
  private remoteConfig = inject(RemoteConfig);
  private angularFireAuth = inject(Auth);
  destroyRef: DestroyRef;
  private keyboardWillShowListener: PluginListenerHandle;
  private keyboardWillHideListener: PluginListenerHandle;

  constructor(
    private tenantService: TenantService,
    public ngZone: NgZone,
    private domCtrl: DomController,
    public appService: AppService,
    private leaguechatservice: leagueChatService,
    public treasurehuntService: TreasurehuntService,
    public platform: Platform,
    private authService: AuthService,
    private pushNotificationService: PushNotificationService,
    private areaService: AreaManagementService,
    private backButtonService: BackButtonService,
    public vpcHazService: VpcHazService,
    private _location: Location,
    public event: Events,
    private route: ActivatedRoute,
    private modalCtrl: ModalController,
    public rapidtourService: RapidtourService,
    private bogTourService: BogTourService,
    private lhStorageService: LhStorageService,
    private renderer: Renderer2,
    public leagueService: LeagueService,
    private audioService: AudioService,
    private stepCountServcie: StepCounterService,
    private detectChanges: ChangeDetectorRef,
    private aIService: AIService,
    public performanceService: PerformanceService,
    public appInfoService: AppInfoService
  ) {
    super();
    this.initializeApp();
    setTimeout(async () => {
      const langselected = await this.lhStorage.get('selectedLanguage');
      if (langselected != null) {
        if (!this.langSynced) {
          this.langSynced = true;
        }
      }
    }, 500);

    // this.treasurehuntService.application_footer_TAB_theme.subscribe(async (res) => {
    //   console.log('Recieved application_footer_Tabs theme ', res);
    //   if (this.currentPage != '')
    //     if (res != null) {
    //       this.app_footer_TAB_theme = "footer_TAB_background " + res;
    //     } else {
    //       this.app_footer_TAB_theme = "footer_TAB_background th_4_default_footer_theme";
    //     }
    // })

    this.treasurehuntService.th_footer_tab_theme.subscribe(async (res) => {
    //  console.log('Recieved th_footer_tab_theme ', res);
      if (this.currentPage != '') {
        if (res != null) {

          this.app_footer_TAB_theme = "footer_TAB_background " + res;
        } else {

          this.app_footer_TAB_theme = "footer_TAB_background th_4_default_footer_theme";
        }
      }
      else {

      }
    })

    // this.setMultiTenantDBName();

    this.treasurehuntService.hunt_play_announcement.subscribe(async (res) => {
    //  console.log('Recieved hunt_play_announcement ', res);
      if (res !== null) {
        this.treasurehuntService.presentHuntPlayAnnouncementModal();
      }
    });

    this.signalUtilsService.createEffect(() => {
      const newAppData = this.appService.refreshedAppData();
      this.activateMenu();
    });
  }

  getConversationtext(text) {
    // if (this.langSynced) {
    //   return this.translate.instant(text);
    // } else {
    return this.translatedefault[text];
    // }
  }
  getFooterTABBtn() {
    if (this.isKeyboardOpen) return 'keyboard-is-open';
    else return 'keyboard-is-close';
  }
  async ngOnInit() {
    this.events.subscribe('user-info-after-login', (res) => {
      this.firstTimeLogin = true;
      this.userDataOnLogin = res;
    });
    this.checkUserRole();
    this.events.subscribe('action-closed', (res) => {
      this.action_api_data();
    });
    this.appService.compassIcon_Subject.subscribe(show => {
      this.showCompassIcon = show;
    });

    this.platform.ready().then(() => {
      try {
        if (Capacitor.getPlatform() === 'ios') {
          StatusBar.setOverlaysWebView({ overlay: true });
        //  StatusBar.setStyle({ style: Style.Light });
        //  StatusBar.setBackgroundColor({ color: '#0d6883' });
        } else if (Capacitor.getPlatform() === 'android') {
          StatusBar.setStyle({ style: Style.Light });
          EdgeToEdge.setBackgroundColor({ color: '#0d6883' });
      //    StatusBar.setBackgroundColor({ color: '#0d6883' });
        }
      } catch (_) { }

      if (Capacitor.isNativePlatform()) {
        Capacitor.isNativePlatform() && Keyboard.addListener('keyboardDidShow', () => {
          this.isKeyboardOpen = true;
          this.ngZone.run(async () => {
            this.getFooterTABBtn();
          });
        });

        Capacitor.isNativePlatform() && Keyboard.addListener('keyboardDidHide', () => {
          this.isKeyboardOpen = false;
          this.ngZone.run(async () => {
            this.getFooterTABBtn();
          });
        });

        this.setupKeyboardListeners();
      }
    });
    App.addListener('appStateChange', async (state: AppState) => {
    //  console.log("App is in state ::", state)
      if (state.isActive) {
        // App is in foreground
     //   console.log('App is in foreground');
      } else {
        // App is in background
     //   console.log("App is in background")
        //if (Capacitor.isNativePlatform())
        //this.appService.lastChatActivityTimeUpdate()
        // if(Capacitor.isNativePlatform() && this.appService.appData.userInfo.shield_user){
        // this.updateStepCountInCurrentTour();
        // }

      }
    });

    this.skipUpdateCount = (await this.lhStorage.get('skipUpdateCount')) || 0;
  //  console.log(this.skipUpdateCount);

    
  }
  async playButtonUpdate() {
    let isModalOpened: any = await this.modalController.getTop();
    let isRapidPlay_popup = false;
    if (isModalOpened != undefined)
      isRapidPlay_popup = isModalOpened.classList.contains("rapid_play_control");
    if (this.currentPage != '/take-rapid-tour' && this.currentPage != "/shield" && isRapidPlay_popup && isModalOpened != undefined)
      this.modalController.dismiss();
  }
  async areaControllerClose() {
    let isModalOpened: any = await this.modalController.getTop();
    let areaPopUp: any;
    if (isModalOpened != undefined)
      areaPopUp = isModalOpened.classList.contains('contoller_option_area_controller');
    if ((this.currentPage != '/area-management-screen' || this.currentPage != '/zone-management-screen') && areaPopUp && isModalOpened != undefined) {
      this.appService.delete_count = 0;
      this.appService.email_count = 0;
      this.modalController.dismiss();
    }
  }
  async initializeApp() {

    await this.lhStorageService.create();
    await this.tenantService.init();
    await this.setMultiTenantDBName();

    await this.action_api_data();
    const appData = await this.lhStorage.get('appData');
    this.appService.bottomControllerStatus.subscribe(async (res) => {
      this.playButtonUpdate();
      this.areaControllerClose();
      if (res === 'TOUR_NOT_STARTED') {
        this.bogTourButtonStatus = 'TOUR_NOT_STARTED';
      } else if (res === 'RAPID_TOUR_NOT_STARTED') {
        this.bogTourButtonStatus = 'RAPID_TOUR_NOT_STARTED';
      } else if (res === 'TOUR_STARTED') {
        this.bogTourButtonStatus = 'TOUR_STARTED';
      } else if (res === 'RAPID_TOUR_STARTED') {
        this.bogTourButtonStatus = 'RAPID_TOUR_STARTED';
      } else if (res === 'INSIDE_BOG_TOUR') {
        //Show Scanner
        this.bogTourButtonStatus = 'INSIDE_BOG_TOUR';
      } else if (res === 'INSIDE_RAPID_TOUR') {
        //Show Scanner
        this.bogTourButtonStatus = 'INSIDE_RAPID_TOUR';
      }
      // else if (res === "RAPID_TOUR_AUTO") {
      //   this.bogTourButtonStatus = "RAPID_TOUR_AUTO";
      // } else if (res === "RAPID_TOUR_MANUAL") {
      //   this.bogTourButtonStatus = "RAPID_TOUR_MANUAL";
      // }
    });
    this.events.subscribe('update_rapid_play_button', (res) => {
      this.playButtonUpdate();
    });
    this.events.subscribe('openTourOptionsController', () => {
      this.openTourOptionsController();
    });
    this.events.subscribe('rating-report-start-tour', () => {
      this.startBogTour();
    });
    this.events.subscribe('tour_option_update', (response) => {
      this.abortBtnFlag = response;
      if (response) this.tour_end_option_text = 'ABORT';
      else this.tour_end_option_text = 'END';
    });
    this.events.subscribe('close-area-contoller', async (res) => {
      let that = this;
      const isModalOpened = await this.modalController.getTop();
      if (isModalOpened) {
        this.modalController.dismiss();
        that.appService.delete_count = 0;
        that.appService.email_count = 0;
      }
    });
    this.appService.bogTourTripTimer.subscribe((res) => {
      //after 4hr auto abort start
      let temp_res = res;
      const timeParts = temp_res.split(':');
      const hours = parseInt(timeParts[0], 10);
      const minutes = parseInt(timeParts[1], 10);
      if (hours >= 4 || (hours === 3 && minutes >= 60)) {
        this.tripTimer = '00:00';
        if (this.appService.appData.userInfo.shield_user == true) {
          this.bogTourButtonStatus = "RAPID_TOUR_NOT_STARTED";
        } else {
          this.bogTourButtonStatus = this.bogTourButtonStatus;
        }
        this.rapidtourService.abortBOGTrip('normal', "");
      } else {
        this.tripTimer = res;
      }
      //after 4hr auto abort end

      // if (res === '04:00') {
      //   this.tripTimer = new BehaviorSubject('0.0')
      // } else {
      // this.tripTimer = res;
      // }
      // this.tripTimer = res;
    });
    this.platform.ready()
      .then(async () => {
        // this.FirebaseCrashlytics.initialise();
        // this.crashlytics.log('This is a log message');
        // this.crashlytics.setUserIdentifier('user123');
        // this.crashlytics.crash();
        try {
          // await StatusBar.setOverlaysWebView({ overlay: false });  // ✅ Pushes content below status bar
          // await StatusBar.setStyle({ style: Style.Dark });          // Optional: match your status bar color
          // await StatusBar.hide();
        } catch {
          console.warn('Native StatusBar not accessible');
        }

        const appData = await this.lhStorage.get('appData');
        if (appData && typeof appData.userInfo !== 'undefined') {
          try {
            if (Capacitor.isNativePlatform()) {
              const permStatus = await PushNotifications.checkPermissions();
              if (permStatus.receive !== 'granted') {
                const delayCheckPushNotification = (time: number) => {
                  setTimeout(() => {
                    this.checkPushNotificationPermission();
                  }, time);
                };
                const time = 3000;
                delayCheckPushNotification(time);
              }
              if (permStatus.receive === 'granted')
                this.pushNotificationService.initPush(appData.userInfo);
            }
          } catch (err) {
            console.error('Error checking push permission:', err);
          }
        }

        this.checkIfRootedDevice();
        setTimeout(() => {
          this.checkFirebaseUpdate();
        }, 10000);

        this.activateMenu();
        this.appService.shieldListSubject.next('AFTER_APP_OPENS');
        this.assignDeviceId();

        if (document.body.classList.contains('qrscanner')) {
          /*To disable back button */
          this.QRbackbuttonSubscription = this.platform.backButton.subscribeWithPriority(
            99999,
            () => { }
          );
        }

        this.platform.backButton.subscribeWithPriority(10, async (processNextHandler) => {
          if (this.modalCtrl.getTop()) {
            const modal = await this.modalCtrl.getTop();
            let currentTour: any = await this.lhStorage.get('currentTour');
            if (modal) {
              let areaPopUp: any;
              areaPopUp =
                modal?.classList.contains('notification-popup-component') ||
                modal?.classList.contains('notification-popup-component2');

              if (areaPopUp) {
                this.events.publish('housekeeping_button_click');
                this.modalCtrl.dismiss().then((res) => {
                  if (currentTour == null && areaPopUp) {
                    this.router.navigate(['/dashboard']);
                  }
                });
              }
            } else if (
              (this._location.isCurrentPathEqualTo('/dashboard') &&
                !document.body.classList.contains('qrscanner')) ||
              this._location.isCurrentPathEqualTo('/house-keeping-review') ||
              this._location.isCurrentPathEqualTo('/action-management') ||
              this._location.isCurrentPathEqualTo('/login')
            ) {
              // Show Exit Alert!
              if (!this.appExitPopupShow) {
                this.showExitConfirm();
                this.appExitPopupShow = true;
              }
              processNextHandler();
            } else if (
              this._location.isCurrentPathEqualTo('/report-dashboard') ||
              this._location.isCurrentPathEqualTo('/user-rating-details') ||
              this._location.isCurrentPathEqualTo('/housekeeping-filter') ||
              this._location.isCurrentPathEqualTo('/my-observations') ||
              this._location.isCurrentPathEqualTo('/admin-module') ||
              this._location.isCurrentPathEqualTo('/take-bog-tour') ||
              this._location.isCurrentPathEqualTo('/treasure-hunt-dashboard') ||
              this._location.isCurrentPathEqualTo('/treasure-hunt-team-selection') ||
              this._location.isCurrentPathEqualTo('/take-rapid-tour')
            ) {
              this.route.queryParams.subscribe(async (params) => {
                // let lastVisistedPage = await this.lhStorage.get('lastVisitedPage');
                if (params['greenPass'] == 'true') {
                  let position;
                  try {
                    position = await Geolocation.getCurrentPosition({
                      enableHighAccuracy: true,
                      timeout: 20000,
                      maximumAge: 10000
                    });
                  } catch (error) {
                    console.warn('High accuracy failed, trying low accuracy:', error);
                    try {
                      position = await Geolocation.getCurrentPosition({
                        enableHighAccuracy: false,
                        timeout: 30000,
                        maximumAge: 30000
                      });
                    } catch (fallbackError) {
                      console.error('Location failed:', fallbackError);
                      return;
                    }
                  }
                  let geolocationData = {
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude,
                  };
                  let newQR = await this.lhStorage.get('takeEndQR');
                  await this.areaService.startNewTour(newQR, geolocationData);
                  this.router.navigate(['/take-bog-tour']);
                } else {
                  // this.router.navigate(['/dashboard']);
                }
              });
              //this.router.navigate(['/dashboard']);
            } else {
              // Navigate to back page
              this._location.back();
            }
          } else {
            if (
              (this._location.isCurrentPathEqualTo('/dashboard') &&
                !document.body.classList.contains('qrscanner')) ||
              this._location.isCurrentPathEqualTo('/house-keeping-review') ||
              this._location.isCurrentPathEqualTo('/action-management') ||
              this._location.isCurrentPathEqualTo('/login')
            ) {
              // Show Exit Alert!
              if (!this.appExitPopupShow) {
                this.showExitConfirm();
              }
              processNextHandler();
            } else if (
              this._location.isCurrentPathEqualTo('/report-dashboard') ||
              this._location.isCurrentPathEqualTo('/admin-module') ||
              this._location.isCurrentPathEqualTo('/housekeeping-filter') ||
              this._location.isCurrentPathEqualTo('/my-observations') ||
              this._location.isCurrentPathEqualTo('/take-bog-tour') ||
              this._location.isCurrentPathEqualTo('/treasure-hunt-dashboard') ||
              this._location.isCurrentPathEqualTo('/treasure-hunt-team-selection')
            ) {
              this.route.queryParams.subscribe(async (params) => {
                let lastVisistedPage = await this.lhStorage.get('lastVisitedPage');
                if (params['greenPass'] == 'true') {
                  let position;
                  try {
                    position = await Geolocation.getCurrentPosition({
                      enableHighAccuracy: true,
                      timeout: 20000,
                      maximumAge: 10000
                    });
                  } catch (error) {
                    console.warn('High accuracy failed, trying low accuracy:', error);
                    try {
                      position = await Geolocation.getCurrentPosition({
                        enableHighAccuracy: false,
                        timeout: 30000,
                        maximumAge: 30000
                      });
                    } catch (fallbackError) {
                      console.error('Location failed:', fallbackError);
                      return;
                    }
                  }
                  let geolocationData = {
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude,
                  };
                  let newQR = await this.lhStorage.get('takeEndQR');
                  await this.areaService.startNewTour(newQR, geolocationData);
                  this.router.navigate(['/take-bog-tour']);
                } else {
                  this.router.navigate(['/dashboard']);
                }
              });

              //this.router.navigate(['/dashboard']);
            } else {
              // Navigate to back page
              this._location.back();
            }
          }
        });

        const activationEndEvents = this.router.events.pipe(filter<ActivationEnd>(e => e instanceof ActivationEnd));
        const navigationEndEvents = this.router.events.pipe(filter<NavigationEnd>(e => e instanceof NavigationEnd));
        navigationEndEvents.pipe(
          withLatestFrom(activationEndEvents)).subscribe(async ([navigationEnd, activationEnd]) => {
          //  console.log("whielist called");
            const pagePath = navigationEnd?.url;
            this.currentPage = navigationEnd.url;
            if (this.currentPage.includes("/observation-add-edit"))
              this.is_obs_screen = true;
            else this.is_obs_screen = false;


            // start -- Rapid compoennt dismiss if it open on other page
            const modal = await this.modalCtrl.getTop();
            if (modal) {
              let isRapidPlay_popup = modal.classList.contains("rapid_play_control");
              if (isRapidPlay_popup && this.currentPage != "/shield") {
                this.modalCtrl.dismiss().then(res => {
                //  console.log("dismiss")
                });
              }
            }
            //End

            // if(this.currentPage !="/take-bog-tour")
            //   this.intermediateOption=false;
            if (this.currentPage == '/dashboard') {
              //this.areaOpt=false;
              this.delete_count = 0;
              this.email_count = 0;
            
            } 

            if (this.currentPage == '/area-management-screen' || this.currentPage=='/zone-management-screen') this.rapidOpt = false;
            if (this.currentPage == '/housekeeping-filter') {
              this.ratingOpt == true;
            }

            this.appService.updatecurrentpage(this.currentPage);

            // Use NgZone to prevent ExpressionChangedAfterItHasBeenCheckedError
            this.ngZone.run(() => {
              if (pagePath !== "/login" && !pagePath.includes("/maps") && pagePath !== '/treasure-hunt-bonus-question' && pagePath !== '/treasure-hunt-map' && pagePath !== '/treasure-hunt-challenges' && pagePath !== '/welcome' && pagePath !== '/treasure-hunt-create' && pagePath !== '/treasure-hunt-management' && pagePath !== '/site-admin-welcome' && pagePath !== '/country-admin-treasure-hunt-notifications' && !pagePath.includes("/location-selection") && !pagePath.includes("/bog-targets") && !pagePath.includes("/register")
                && pagePath != "/add-new-area" && !pagePath.includes("/bonus-introduction") && !pagePath.includes("/bonus-question-unlock") && !pagePath.includes("/expert-question-unlock") && !pagePath.includes("/challenge-questions") && !pagePath.includes('/expert-introduction') && !pagePath.includes('/TH-chat') && !pagePath.includes('/th-request-sponsorship') && !pagePath.includes('/th-story')
                && pagePath != "/edit-area-management" && !pagePath.includes("/circuit-view?") && !pagePath.includes("/user-rating-details?") && !pagePath.includes('/team-registration-flow') && !pagePath.includes('/shield-heat-map') && pagePath !== '/rapid-draft' &&
                !pagePath.includes("/otp?") && !pagePath.includes("/user-feedback") && !pagePath.includes("/qr-management") && !pagePath.includes("/qr-generated-success") && !pagePath.includes("/key-lesson-pues-videos") && pagePath !== "/rapid-assessment-report" && !pagePath.includes("/action-closure") && pagePath !== '/report-dashboard' && !pagePath.includes("/add-findings") &&
                !pagePath.includes("/more") && pagePath != "/rapid-observation" && !pagePath.includes('treasure-hunt-team-selection') && pagePath !== '/auto-join-team' && !pagePath.includes("/finding-details?") && !pagePath.includes("/treasure-hunt-station-unlock?") && !pagePath.includes("/th-add-findings") && !pagePath.includes('/treasure-hunt-finding-discovered-list') && !pagePath.includes('/rapid-observation') &&
                !pagePath.includes('/league-chat') && !pagePath.includes('/end-hunt-open-mystery-box') && !pagePath.includes('/end-hunt-submit') && !pagePath.includes('/end-hunt-exit') && !pagePath.includes('/th-end-finding-list') && !pagePath.includes('/th-end-teams-story') && !pagePath.includes('/th-end-team-picture') && !pagePath.includes("/fire-flame") && !pagePath.includes("/fire-streak") &&
                !pagePath.includes('/all-shield-verify-action') && !pagePath.includes("/finding-action-list") && pagePath !== '/rapid-landing-screen' && !pagePath.includes('structural-assessment') && !pagePath.includes('structure-finding-details') && !pagePath.includes('i-hunt') && !pagePath.includes('th-findings-listing') && !pagePath.includes('th-finding-details') && !pagePath.includes('/rating-and-report')
                && !pagePath.includes('/th-mystery-box')) {
                this.showTabs = true;
              } else {
                this.showTabs = false;
              }
            });

            // Use NgZone to prevent ExpressionChangedAfterItHasBeenCheckedError
            this.ngZone.run(() => {
              if (pagePath == '/dashboard' || pagePath.includes('/take-bog-tour')) {
                this.showBubble = true;
              } else {
                this.showBubble = false;
              }
            });

            if (!pagePath.includes('/treasure-hunt-dashboard') || !pagePath.includes('/leagues')) {
              //this.appService.lastChatActivityTimeUpdate();
            }

            // Use NgZone to prevent ExpressionChangedAfterItHasBeenCheckedError
            this.ngZone.run(() => {
              if (pagePath.includes('/vpc-haz') || pagePath.includes('/observation-add-edit')) {
                this.replaceLeftTabsWtBtn = {
                  text: 'Cancel',
                  click: () => {
                    this.vpcHazService.cancelObservable.next(true);
                  },
                };
                this.replaceRightTabsWtBtn = {
                  text: 'Submit',
                  disabled: () => {
                    if (this.vpcHazService.mode == 'edit' && !this.vpcHazService.viewOnly) {
                      if (this.vpcHazService.vpcHazForm.valid) {
                        return !this.vpcHazService.updateObservationEnabled;
                      } else {
                        return true;
                      }
                    } else if (this.vpcHazService.viewOnly) {
                      return true;
                    } else {
                      return !this.vpcHazService.vpcHazForm.valid;
                    }
                  },
                  click: () => {
                    this.vpcHazService.submitObservable.next(true);
                  },
                };
              }
              else if (pagePath.includes("/observation-add-edit")) {
                // Hide footer buttons for observation-add-edit page - buttons are now in the page itself
                this.replaceLeftTabsWtBtn = false;
                this.replaceRightTabsWtBtn = false;
              } else {
                this.replaceLeftTabsWtBtn = false;
                this.replaceRightTabsWtBtn = false;
              }
            });

            this.lastVisitedPage = await this.lhStorage.get('lastVisitedPage');
            let treasure_hunt_data = await this.lhStorage.get('treasureHunt');
            if (pagePath !== 'dashboard' && this.showTabs && treasure_hunt_data != undefined)
              this.isTreasureHuntEnabled = treasure_hunt_data.isTreasureHuntEnabled;

            const screenName =
              (activationEnd.snapshot.routeConfig && activationEnd.snapshot.routeConfig.path) ||
              pagePath;
            const params = activationEnd.snapshot.queryParams;
            if (screenName != 'treasure-hunt-finding-discovered-list' && screenName != 'finding-details') {
              await this.lhStorage.set('lastVisitedPage', screenName);
              if (params) {
                await this.lhStorage.set('lastVisitedPageParams', { queryParams: params });
              }
            }
            await this.TourButtonUpdate(pagePath);
            let huntFlag = await this.lhStorage.get('nearByPlantFlag');
            this.isTreasureHuntEnabled = !huntFlag;
          });
        this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
          if (event.lang == 'ar') {
            this.textDir = 'rtl';
          } else {
            this.textDir = 'ltr';
          }
        });
      });

    this.policyMenu = {
      params: {
        queryParams: {
          fromPage: 'PRIVACY_POLICY',
          queryParamsHandling: 'preserve',
          title: 'PRIVACY_POLICY_TITLE',
          url: 'https://bogglobaldocs-prod.web.app/privacyPolicy.html',
        },
      },
      title: 'PRIVACY_POLICY_TITLE',
      url: '/policy-and-terms',
    };
  //  console.log("policyMenu", this.policyMenu);
    this.event.subscribe('treasureHuntEnable', (res) => {
      this.isTreasureHuntEnabled = res;
    });
    this.event.subscribe('currentSiteInfo', (res) => {
      this.currentSiteData = res;
    });
    this.event.subscribe('update_RapidBtn', (res) => {
      this.TourButtonUpdate('more');
    });
    this.event.subscribe('bogPageEvent', (value) => {
      this.handleBogPageEvent(value);
    });
    await this.leagueService.checkLeagueCurrentFlow();
    let currentTour: any = await this.lhStorage.get('currentTour');
    await this.aIService.loadAIModels();
    await this.leagueService.getCountryIcons();
    //  await this.performanceService.getCountryFlags();
  }
  async TourButtonUpdate(pagePath) {
    this.platform.ready()
      .then(async () => {
        const currentTour = await this.lhStorage.get('currentTour');
        if (this.appService.appData != undefined && (this.appService.appData.userInfo?.shield_user === undefined || this.appService.appData.userInfo?.shield_user == false)) {
          if (pagePath == "/take-bog-tour") {
            this.endTripTime();
            this.appService.updateBottomControllerStatus("INSIDE_BOG_TOUR");
          } else {
            if (currentTour && currentTour?.currentBogTourInfo !== undefined) {
              this.starTripTime();
              this.appService.updateBottomControllerStatus("TOUR_STARTED");
            } else {
              this.endTripTime();
              this.appService.updateBottomControllerStatus("TOUR_NOT_STARTED");
            }
          }
        } else {
          // rapid
          this.starTripTime();
          if (pagePath == "/take-rapid-tour") {
            // this.appService.updateBottomControllerStatus("INSIDE_RAPID_TOUR");
            this.endTripTime();
          } else {
            if (currentTour && currentTour?.currentBogTourInfo?.rapidTourId !== undefined) {
              this.appService.updateBottomControllerStatus('RAPID_TOUR_STARTED');
            } else {
              this.endTripTime();
              this.appService.updateBottomControllerStatus('RAPID_TOUR_NOT_STARTED');
            }
          }
        }
      });
  }
  async starTripTime() {
    const currentTour = await this.lhStorage.get('currentTour');
    if (currentTour != undefined && currentTour != null) {
      this.bogTourTripSubscriber = timer(1000, 1000).subscribe(async () => {
        let startTime: any, endTime: any;
        const currentTour = await this.lhStorage.get('currentTour');
        if (currentTour != undefined && currentTour != null && currentTour.currentBogTourInfo) {
          startTime = currentTour.currentBogTourInfo.startTime;
          endTime = this.moment().toISOString();
          let triptime = this.moment(endTime).diff(this.moment(startTime), 'minutes');
          let bogTripTotalTime;
          if (triptime > 59) {
            let hours = Math.floor(triptime / 60);
            let minutes = triptime % 60;
            // this.bogTripTotalTime = hours + ' hours and ' + minutes + ' minutes';
            bogTripTotalTime = `${('0' + hours).slice(-2)}:${('0' + minutes).slice(-2)}`;
          } else {
            // this.bogTripTotalTime = this.bogTripTotalTime + ' minutes';
            bogTripTotalTime = `00:${('0' + triptime).slice(-2)}`;
          }
          this.appService.updateBogTourTripTimer(bogTripTotalTime);
        }
      });
    } else this.appService.updateBogTourTripTimer('00:00');
  }
  endTripTime() {
    if (this.bogTourTripSubscriber) {
      this.bogTourTripSubscriber.unsubscribe();
    }
  }

  async action_api_data() {
    if (this.appService.connectionState) {
      const user = await lastValueFrom(authState(this.angularFireAuth).pipe(first()));
      if (!user) {
        return;
      }
   //   console.log("inside action_api_data");
      const appData = await this.lhStorage.get('appData');
      if (appData && appData.userInfo != undefined) {
        let requestData;
        requestData = {
          email: appData.userInfo.email,
          person_id: appData.userInfo.person_id,
          filters: [],
        };
        // const getOverdueActionCountUserCallable = this.apiService.httpsCallable(`getTODOActions`);
        // getOverdueActionCountUserCallable(requestData).subscribe(async (response) => {
        //   if (response.data.actionsAssignedToMe.length > 0) {
        //     let todoListData = response.data.actionsAssignedToMe;
        //     let calulationStartDate = this.moment().format("YYYY-MM-DD");
        //     this.overdueActionCount = todoListData.filter(item => (item.due_date < calulationStartDate && item.sn_status == 'Open'));
        //   }
        // })
        // Define the `where` conditions to pass as parameters
        let calulationStartDate = this.moment().format("YYYY-MM-DD");
        const conditions = [
          where('dwk_assigned_to', '==', appData.userInfo.person_id),
          where('sn_status', '==', 'Open'),
          where('due_date', '<', calulationStartDate)
        ];
        this.lhFire.getCollectionGroupForTanentAsync('actions', ...conditions)
          .subscribe(actionsFireSnapshot => {
            // Handle the snapshot when it arrives
          //  console.log('Actions loaded in background:', actionsFireSnapshot);
            // You can update your state here if needed
            let actionsFire = actionsFireSnapshot.docs.map((doc: any) => doc.data());
            this.overdueActionCount = actionsFire.length;
          //  console.log(this.overdueActionCount);
          });
      }
    }
  }
  showExitConfirm() {
    this.alertController
      .create({
        header: this.translate.instant('APP_TERMINATION'),
        message: this.translate.instant('DO_YOU_WANT_TO_CLOSE_THE_APP'),
        backdropDismiss: false,
        cssClass: 'abort-alert',
        buttons: [
          {
            text: this.translate.instant('APP_STAY'),
            role: 'cancel',
            handler: () => {
              this.appExitPopupShow = false;
            },
          },
          {
            text: this.translate.instant('TREASURE_HUNT.EXIT'),
            role: 'ok',
            handler: () => {
              navigator['app'].exitApp();
              this.appExitPopupShow = false;
              // this.stepCountServcie.stopBGS();
            },
          },
        ],
      })
      .then((alert) => {
        alert.present();
        this.appExitPopupShow = true;
      });
  }
  // Tushar: Need to move this to library
  getGreetingTime() {
    let greet = null; // return g

    if (!this.moment() || !this.moment().isValid()) {
      return;
    } // if we can't find a valid or filled moment, we return.
    const SPLIT_AFTERNOON = 12; // 24hr time to split the afternoon
    const SPLIT_EVENING = 17; // 24hr time to split the evening
    const currentHour = parseFloat(this.moment().format('HH'));

    if (currentHour >= SPLIT_AFTERNOON && currentHour <= SPLIT_EVENING) {
      greet = this.translate.stream('APP_GREET_GA');
    } else if (currentHour >= SPLIT_EVENING) {
      greet = this.translate.stream('APP_GREET_GE');
    } else {
      greet = this.translate.stream('APP_GREET_GM');
    }
    return greet;
  }

  toggleMenu() {
    this.logger.log('MENU TOGGLED');
  }

  redirectToSelectedMenu(menu) {
    this.logger.info('MENU SELECTED IS :', menu);
    if (
      menu.url === '/workgroup-management' ||
      menu.url === '/user-management' ||
      menu.url === '/policy-and-terms' ||
      menu.url === '/report-dashboard'
    ) {
      this.logger.info('INTERNET CONNECTIVITY IS :', this.appService.connectionState);
      if (this.appService.connectionState) {
        if (menu.url === '/policy-and-terms') {
          this.menuCtrl.close();
          this.router.navigate([menu.url], menu.params || {});
        }

        if (
          this.appService.appData.userInfo.role === 'super_user' ||
          this.appService.appData.userInfo.role === 'country_admin'
        ) {
          if (menu.url === '/user-management') {
            this.router.navigate(['/user-management-by-plants'], menu.params || {});
          } else {
            this.router.navigate([menu.url], menu.params || {});
          }
        } else if (this.appService.appData.userInfo.role === 'admin') {
          if (menu.url === '/user-management') {
            if (
              typeof this.appService.appData.userInfo.plants_assigned === 'undefined' ||
              this.appService.appData.userInfo.plants_assigned.length === 0
            ) {
              this.router.navigate(['/user-management-by-plants'], menu.params || {});
            } else {
              this.router.navigate(['/user-management'], menu.params || {});
            }
          } else {
            this.router.navigate([menu.url], menu.params || {});
          }
        }
      } else {
        this.overlayService.presentToast(
          this.createToastOptions(this.translate.instant('INTERNET_CONNECTION_FEATURE'))
        );
      }
    } else {
      this.router.navigate([menu.url], menu.params || {});
    }
  }
  async checkIfRootedDevice() {
    const rootedValue = await JailbreakRoot.isJailbrokenOrRooted();
    if (rootedValue.result) {
      let alert = await this.alertController.create({
        message: 'Your device is rooted. To continue using this app, please fix this issue first.',
        cssClass: 'abort-alert',
        backdropDismiss: false,
        buttons: [
          {
            text: 'Exit',
            role: 'ok',
            handler: () => {
              navigator['app'].exitApp();
            },
          },
        ],
      });
      alert.present();
    }
  }


  async checkFirebaseUpdate() {
    if (this.appService.connectionState && Capacitor.isNativePlatform()) {
      const appVersion: string = this.platform.is('mobileweb')
        ? '5.11.11'
        : (await App.getInfo()).version;

      // Set default remote config values

      // defaultConfig(this.remoteConfig, res => {
      //   this.logger.log('RESPONSE FROM DEFAULT CONFIG IS :', res);
      // }, error => {
      //   this.logger.error('ERROR FROM DEFAULT CONFIG IS :', error);
      // });

      // Fetch all remote config and activate them
      await fetchAndActivate(this.remoteConfig);

      // Fetch app version config
      const appVersionConfig = getValue(this.remoteConfig, 'appVersionConfig');
      this.logger.log(JSON.parse((appVersionConfig as any)._value));
      const app_update_config = JSON.parse((appVersionConfig as any)._value);

      this.lhStorage.set('th_finding_radius', app_update_config.th_finding_radius);
      this.lastUpdateTime = new Date(app_update_config.force_update_date);
      //this.lastUpdateTime.setDate(this.lastUpdateTime.getDate() + 3);
      const timeoutInterval = parseInt(app_update_config.pop_up_duration) * 60 * 60 * 1000; // 8 hours in milliseconds
      this.lastPopUpTime = (await this.lhStorage.get('lastPopUpTime')) || 0;

      if (
        parseInt(appVersion.replace(/\./g, '')) <
        parseInt(app_update_config.app_version.replace(/\./g, ''))
      ) {
        if (
          Date.now() - this.lastPopUpTime >= timeoutInterval ||
          Date.now() >= Date.parse(this.lastUpdateTime.toDateString())
        ) {
          this.showUpdateAlert(app_update_config);
          this.lhStorage.set('lastPopUpTime', Date.now());
        }
      } else {
        this.lhStorage.remove('lastPopUpTime');
        this.lhStorage.remove('skipUpdateCount');
      }

      // Fetch terms and conditions config and store it
      const termsAndConditionConfig = getValue(this.remoteConfig, 'terms_and_conditions');
      this.logger.log(JSON.parse((termsAndConditionConfig as any)._value));
      await this.lhStorage.set(
        'terms_and_conditions',
        JSON.parse((termsAndConditionConfig as any)._value)
      );
    }
  }

  async showUpdateAlert(data) {
    const laterBtnText = 'Later\n(after 8 hours)';
    const nowBtnText = 'Update now';
    // const laterBtnText = this.translate.instant('APP.ALERT.FORCE_UPDATE.BUTTON.NO');
    // const nowBtnText = this.translate.instant('APP.ALERT.FORCE_UPDATE.BUTTON.YES');

    let btns = [];
    if (data.force_update) {
      if (Date.now() <= Date.parse(this.lastUpdateTime.toDateString())) {
        btns.push({
          // text: this.translate.instant('ADD_QR.BTN_LATER'),
          text: laterBtnText,
          cssClass: '',
          handler: () => {
            this.skipForceUpdate(data);
          },
        });
      } else {
        btns.push({
          // text: this.translate.instant('ADD_QR.BTN_LATER'),
          text: laterBtnText,
          cssClass: 'btn-inactive',
        });
      }
      btns.push({
        // text: this.translate.instant('ADD_QR.BTN_UPDATE'),
        text: nowBtnText,
        handler: () => {
          this.openMarketPage(data);
        },
      });

      let alert = await this.alertController.create({
        header: data.alert_title,
        message: data.alert_message,
        // cssClass: 'update-alert',
        cssClass: ['force-update-alert'],
        buttons: btns,
        backdropDismiss: false,
      });

      await alert.present();
    }
  }
  skipForceUpdate(data) {
   // console.log(data.launch_date + 3);
    let lastDate = new Date(data.launch_date);
    lastDate.setDate(lastDate.getDate() + 3);
  //  console.log(lastDate);
    this.lhStorage.set('skipUpdateCount', this.skipUpdateCount + 1);
    // this.appService.setSkipUpdateCount(this.skipUpdateCount + 1);
  }
  openMarketPage(data) {
    this.lhStorage.remove('lastPopUpTime');
    this.lhStorage.remove('skipUpdateCount');
    if (this.platform.is('android')) {
      if (data.force_update_android_store_url) {
        this.inAppBrowser.open({
          url: data.force_update_android_store_url,
          windowName: '_system',
        });
        this.forceUpdateSubscription.unsubscribe();
      }
      return true;
    } else if (this.platform.is('ios')) {
      if (data.force_update_iOS_store_url) {
        this.inAppBrowser.open({
          url: data.force_update_iOS_store_url,
          windowName: '_system',
        });
        this.forceUpdateSubscription.unsubscribe();
      }
      return true;
    }
  }

  activateMenu() {
    this.menuList = this.appService.menuChanged;
    this.menuDir = this.appService.menuDir;
    this.menuCtrl.enable(true);

    this.domCtrl.write(async () => {
      this.greet = await this.getGreetingTime();
      if (this.platform.is('cordova')) {
        this.versionNumber = (await App.getInfo()).version;
      } else if (this.platform.is('mobileweb')) {
        this.versionNumber = environment.app_version;
      }
    });
  }

  async assignDeviceId() {
    const deviceId = await this.lhStorage.get('uniqueDeviceId');
    if (!deviceId) {
      await this.lhStorage.set('uniqueDeviceId', uuidv4());
    }
  }

  stopScanner() {
    if (document.body.classList.contains('qrscanner')) {
      document.body.classList.remove('qrscanner');
      this.qrcodeScanner.hideBackground();
      this.qrcodeScanner.stopScan();
    }
    this.torchOnOff = true;
  }
  async starttreasurehunt() {
    this.events.publish('treasurehunt_click', '');
  }

  on_home_click() {
    this.router.navigate(['/dashboard'], { replaceUrl: true });
  }

  async action_mgmt() {
    if (this.appService.connectionState) {
      if (this.appService.appData.userInfo?.shield_user == true) {
        this.checkUserRole();
        this.router.navigate(['/action-management'], { replaceUrl: true });
      } else {
        this.checkUserRole();
        this.router.navigate(['/action-management-non-hse'], { replaceUrl: true });
      }
    }
  }

  async checkStatus() {
    //this.modalController && this.modalController.dismiss();
    this.checkUserRole();
  }

  async housekeeping() {
    // this.fab.close();
    if (this.appService.connectionState) {
      this.rapidOpt = false;
      this.checkUserRole();
      this.router.navigate(['/housekeeping-filter'], { replaceUrl: true });
    }
  }

  async performance() {
    if (this.appService.connectionState && this.appService.isFlagsFetched) {
      this.router.navigate(["/performance"], { replaceUrl: true });
    }
  }

  async startBogTour() {
    this.bogTourService.takeBOGTour();
    //QA Emulator
    // this.bogTourService.openBogTourPage('ab905263-5e3f-4b07-8557-a6727eee4e47');
  }
  // openIntermediateQr() {
  //   this.events.publish("Intermediate", "");
  // }
  async setResumeFlags() {
    await this.lhStorage.set('rapidTour_resume_flag', false);
    await this.lhStorage.set('rapidend_flag', false);
    await this.lhStorage.set('isfromcompleteAssessmentReport', false);
  }
  hasRnDRole(): boolean {
    try {
      if (!this.appService.appData || !this.appService.appData.userInfo) {
      // ("No user info available for role check");
        return false;
      }
      const userRoles = this.appService.appData.userInfo.extra_role || [];
      const hasRnD = userRoles.includes('RnD');

      return hasRnD;
    } catch (error) {
    //  console.error("Error checking user role:", error);
      return false;
    }
  }
  async zoneOption() {

    let currentTour = await this.lhStorage.get("currentTour");
    if (currentTour != null) {

      this.openTourOptionsController();

    } else {
      // Check if user is within any configured zone
      let tourData = await this.appService.checkUserLocationInConfiguredZones();
    //  console.log("startour==" + JSON.stringify(tourData));

      if (tourData) {
      //  console.log('User is within zone:', tourData.zone.id);

        // Get current location for tour start
        const currentLocation = tourData.currentLocation;

        if (currentLocation?.latitude && currentLocation?.longitude) {
          // Create zone data for BOG tour start
          const zoneDataForTour = {
            zone: tourData.zone.id || 'Unknown Zone',
            latLong: `${currentLocation.latitude},${currentLocation.longitude}`,
            zoneData: tourData,
            currentLocation: currentLocation
          };

         // console.log('Starting BOG tour with zone data:', zoneDataForTour);

          // Start BOG tour using the zone data
          const tourResult = await this.bogTourService.openBogTourPage(null, zoneDataForTour);
        //  console.log('BOG tour started successfully:', tourResult);

        } else {
       //   console.log('Unable to get current location for tour start');
          this.overlayService.presentToast(
            this.createToastOptions('Unable to get your location. Please enable location services.')
          );

        }

      } else {
      //  console.log('User is not within any configured zone');
        this.overlayService.presentToast(
          this.createToastOptions('You are not within any configured zone. Please move to a valid zone to start the tour.')
        );

      }
    }


  }
  async rapidOption() {
    let currentTour = await this.lhStorage.get("currentTour");

    this.treasurehuntService.updateTHFooterTheme('');
    if (currentTour != undefined && !this.rapidtourService.isEmpty(currentTour))
      this.openTourOptionsController();
    else {
      this.rapidtourService.updateRapidScanMode('manual');
      this.rapidtourService.takeRapidTour();
    }
  }



  async openTourOptionsController() {
   
    if (this.isControllerOptionOpen == false) {
      this.isControllerOptionOpen = true;
      this.rapidOpt = false;
      const modal = await this.modalCtrl.create({
        component: ControllerOptionsComponent,
        cssClass: this.appService.appData.userInfo.shield_user ? 'contoller_option_rapid' : 'contoller_option',
        backdropDismiss: true,
        componentProps: {
          from_page: 'rapid_intermediate_options',
        },
      });
      modal.onDidDismiss().then((modelData) => {
         this.isControllerOptionOpen = false;
      });
      return await modal.present();
    } else {
      this.modalController.dismiss();
      this.isControllerOptionOpen = false;
    }
  }

  async flashLightOn() {
    await this.qrcodeScanner
      .getTorchState()
      .then(async (torchState) => {
        this.torchOnOff = torchState.isEnabled;
        this.qrcodeScanner.toggleTorch();
      })
      .catch((error) => {
        this.logger.log('ERROR OPENING BARCODE SCANNER :', error);
      });
  }

  ionViewWillLeave() {
    this.QRbackbuttonSubscription.unsubscribe();
  }
  // async draftClick() {
  //   // this.rapidOpt=false;
  //   this.fab.close();
  //   await this.lhStorage.remove("currentRapid");
  //   this.router.navigate(['/my-activities']);
  //   }

  async openHamburger() {
    this.checkUserRole();

    // let isNewVersionAvailable = await this.appInfoService.getNewUpdateStatus();

    const modalCtrl = await this.modalController.create({
      component: MorePage,
      backdropDismiss: true,
      cssClass: 'MorePageCss',
      componentProps: {
        // isNewVersionAvailable: isNewVersionAvailable,
      },
    });
    await modalCtrl.present();
    const { data } = await modalCtrl.onWillDismiss();
  }

  siteRatings() {
    this.onCloseFab();
    this.router.navigate(['/site-rating'], { replaceUrl: true });
  }

  areaRatings() {
    if (this.isAreaOwner) {
      this.onCloseFab();
      this.router.navigate(['/area-rating'], { replaceUrl: true });
    }
  }

  housekeepingNav() {
    this.isMoreButtonOpen = true;
    // this.onCloseFab();
  }

  // async AutoScanEndBtn() {
  //   await this.overlayService.presentLoading(
  //     this.createLoaderOptions(this.translate.instant('APP_LOADING_LABEL'))
  //   );
  //   let geolocationData = await this.getCurrentLocation(5000);
  //   //  let geolocationData = { "latitude": "8.845355", "longitude": "77.380841" };
  //   let current_nearbyZone_QR = await this.rapidtourService.getnearByQR(geolocationData);
  //   await this.overlayService.dismissLoading();
  //   if (current_nearbyZone_QR.length > 0) {
  //     this.rapidtourService.TourEndConfirmation('rapid-findings-list');
  //   } else {
  //     let msg = this.translate.instant('YOU_ARE_NOT_NEAR_BY_ANY_ZONES');
  //     this.overlayService.presentToast(this.createToastOptions(msg));
  //   }
  // }
  async showMoreOption() {
    this.areaOpt = !this.areaOpt;
    this.appService.updateAreaManagementOptions(false);
    //this.events.publish('controller_dissmiss','');
    if (this.isControllerOptionOpen == false) {
      this.appService.updateAreaManagementOptions(true);
      this.isControllerOptionOpen = true;
      this.rapidOpt = false;
      const modal = await this.modalCtrl.create({
        component: ControllerOptionsComponent,
        cssClass: 'contoller_option_area_controller',
        backdropDismiss: false,
        componentProps: {
          from_page: 'area',
        },
      });
      modal.onDidDismiss().then((modelData) => {
        this.isControllerOptionOpen = false;
        this.appService.email_count = 0;
        this.appService.delete_count = 0;
      });
      return await modal.present();
    } else {
      // this.events.destroy("delete_area_zone");
      this.appService.email_count = 0;
      this.appService.delete_count = 0;
      this.events.publish('controller_dissmiss', '');
      this.modalController.dismiss();
      this.isControllerOptionOpen = false;
    }
  }
  onCloseFab() {
    this.fab.close();
  }
  // checking User Role
  async checkUserRole() {
    this.isAreaOwner = await this.lhStorage.get('isAreaManager');
    const appData = await this.lhStorage.get('appData');
  }
  async openIntermediateOptions() {
    // Prevent multiple rapid clicks
    if (this.isControllerOptionOpen) {
      return;
    }
    this.isControllerOptionOpen = true;
    try {
      this.rapidOpt = false;
      const modal = await this.modalCtrl.create({
        component: ControllerOptionsComponent,
        cssClass: this.appService.appData.userInfo.shield_user ? 'contoller_option_rapid' : 'contoller_option',
        backdropDismiss: true,
        componentProps: {
          from_page: 'tour_intermediate_options',
        },
      });
      modal.onDidDismiss().then((modelData) => {
        this.isControllerOptionOpen = false;
      });
      return await modal.present();
    } catch (error) {
      this.isControllerOptionOpen = false;
      throw error;
    }
  }
  // async openIntermediateOptions(){

  // this.isMoreButtonOpen=false;
  // this.intermediateOption = !this.intermediateOption;
  // const modal = await this.modalCtrl.create({
  //   component:IntermediateOptionsComponent ,
  //   cssClass: 'tour_options',
  //   componentProps: {
  //     popup_mode: "qr-popup"
  //   }
  // });
  // modal.onDidDismiss();
  // return await modal.present();
  // }
  // async BoGtourEnd(){
  //   this.fab.close()
  //   if(this.abortBtnFlag)
  //     this.events.publish("abort_btn_option", "");
  //   else this.events.publish("end_btn_option", "");
  // }
  checkWrkgrpMgmt() {
    if (
      this.currentPage == '/workgroup-management' &&
      this.appService.appData.userInfo.role == 'admin'
    )
      return false;
    else return true;
  }
  async startNewRapidTour() {
    await this.overlayService.presentLoading(this.createLoaderOptions(this.translate.instant("APP_LOADING_LABEL")));
    try {
      let rapid_data = await this.rapidtourService.getUserCurrentPlantRapidList();
      if (rapid_data.success) {
        await this.lhStorage.remove("currentRapid");
        await this.lhStorage.set('rapidTour_resume_flag', false);
        await this.lhStorage.set("rapidend_flag", false);
        await this.rapidtourService.startRapidTour();
      }
      else {
        // Removed toast message - silent handling when assessment already submitted
        let currentRapid = await this.lhStorage.get("currentRapid");
        if (currentRapid == undefined) {
          await this.lhStorage.set('currentRapid', rapid_data.data);
        }
      }
    } catch (error) {
      console.error('Error in startNewRapidTour:', error);
    } finally {
      await this.overlayService.dismissLoading();
    }
  }


  async openControllerOptions() {
    // this.appService.loadingShieldDataFromServer = true;
    if (this.appService.loadingShieldDataFromServer) {
      const alert = await this.modalController.create({
        component: BogTourModalComponent,
        componentProps: {
          isInitialLoad: true
        },
        //cssClass: 'message-action-sheet-modal',
        breakpoints: [0.5, 0.8, 1],
        initialBreakpoint: 0.5,
        handle: false,
        backdropDismiss: false,
        handleBehavior: 'none',
        canDismiss: false 
      });
      alert.onDidDismiss().then(async (res: any) => {
        if(res) {
          await this.startNewRapidTour();
          this.router.navigate(['/shield']);
        }
      });

      await alert.present();
      return;
    }
//   console.log("shield button click");
    let shieldStory=await this.lhStorage.get('shieldStorySkip');
    if(shieldStory==null|| shieldStory==undefined || shieldStory===false)
      this.shieldOnBoardScreen();
    else {
         await this.startNewRapidTour();
        this.router.navigate(['/shield']);
    }
 
    //this.router.navigate(['/rapid-draft']);
    // if (this.isControllerOptionOpen == false) {
    //   this.isControllerOptionOpen = true;
    //   this.rapidOpt = false;
    //   const modal = await this.modalCtrl.create({
    //     component: ControllerOptionsComponent,
    //     cssClass: 'contoller_option',
    //     backdropDismiss: true,
    //     componentProps: {
    //       from_page: "rapid_options"
    //     }
    //   });
    //   modal.onDidDismiss().then((modelData) => {
    //     this.isControllerOptionOpen = false;
    //   });
    //   return await modal.present();
    // }
    // else {
    //   this.modalController.dismiss();
    //   this.isControllerOptionOpen = false;
    // }
  }

 async shieldOnBoardScreen(){
  const storyModal = await this.modalController.create({
          component: ShieldOnBoardingSlidesComponent,
          cssClass: '',
          backdropDismiss: true,
          componentProps: {}
        });
        storyModal.onDidDismiss().then(async (data:any) => {
        //  console.log("data=",data);
            if(data?.data?.skip){
                 await this.startNewRapidTour();
                 this.router.navigate(['/shield']);
            }
        });
    
        return await storyModal.present();
  }
  async footerScannerBtn(frompage) {
    if (
      this.currentPage.includes('/vpc-haz') ||
      this.currentPage.includes('/observation-add-edit')
    ) {
      let lastVisitedPageParams = await this.lhStorage.get('lastVisitedPageParams');
      let params: any = lastVisitedPageParams.queryParams;
      if (params.obsId != undefined)
        this.router.navigate(['/' + frompage]);
      else
        this.appService.ObsconfirmationDiscard('/' + frompage);

    }
    else if (frompage === 'take-rapid-tour') {
      this.router.navigate(['/shield']);
    }
    else
      this.router.navigate(['/' + frompage]);
  }

  async updateStepCountInCurrentTour() {
    let currentDate = this.moment().format('DD-MM-yyyy');
    let res: any = await this.lhStorage.get("stepCounter");
  //  console.log("stepCount when app in background=", this.stepCountServcie.stepCount);
    if ((!!res) && (res.currentDate == currentDate)) {
      res.stepCount = res.stepCount + this.stepCountServcie.stepCount;
      res.caloriesBurn = res.stepCount * 0.04;
      res.staircase = res.stepCount / 16;
      await this.lhStorage.set('stepCounter', res);
    } else {
      let stepCount = this.stepCountServcie.stepCount;
      let caloriesBurn: any = stepCount * 0.04;
      let staircase: any = stepCount / 16;
      let obj: any = { stepCount: stepCount, caloriesBurn: caloriesBurn, staircase: staircase, currentDate: currentDate };
      await this.lhStorage.set('stepCounter', obj);
    }
  }

  //speech to text code may be required in next version so commenting as of now

  // async triggerMicClickOnActiveInput() {
  //   const { available } = await SpeechRecognition.available();
  //   console.log('Speech Recognition available:', available);

  //   // Start speech-to-text if available and not already listening
  //   if (available && !this.isListening) {
  //     const activeElement = document.activeElement as HTMLInputElement | HTMLTextAreaElement;

  //     // Start speech recognition only if the active input field is empty
  //     if (activeElement && !activeElement.value.trim()) {
  //       this.isListening = true; // Set the listening state
  //       this.speakText();
  //       try {
  //           await SpeechRecognition.start({
  //             language: 'en-US',
  //             maxResults: 2,
  //             prompt: 'Say something',
  //             partialResults: true,
  //             popup: true,
  //           });

  //           // Listen for partial results
  //           SpeechRecognition.addListener('partialResults', (data: any) => {
  //             console.log('Partial results received:', data);
  //             const speechData = data.matches;
  //             if (speechData && speechData.length > 0) {
  //               this.myText = speechData[0];
  //               console.log('Recognized text:', this.myText);

  //               // Update the active input element with recognized text
  //               if (activeElement) {
  //                 activeElement.value = this.myText;
  //                 activeElement.dispatchEvent(new Event('input')); // Trigger Angular's ngModel or form updates
  //               }
  //               this.ngZone.run(() => {});
  //             }
  //           });
  //           SpeechRecognition.addListener('listeningState', (data: any) => {
  //             console.log('listeningState results received:', data);
  //           });
  //           // Add listener to detect manual typing and stop speech-to-text
  //           this.addManualInputListener(activeElement);
  //       }
  //       catch(error:any){
  //         console.error('Error starting speech recognition:', error);
  //         this.isListening = false;
  //       }
  //     }
  //   }
  // }

  // addManualInputListener(activeElement: HTMLInputElement | HTMLTextAreaElement) {
  //   if (activeElement) {
  //     const manualInputHandler = () => {
  //       if (this.isListening) {
  //         this.stopSpeechRecognition(); // Stop recognition if user types manually
  //       }
  //       activeElement.removeEventListener('input', manualInputHandler); // Cleanup listener
  //     };

  //     activeElement.addEventListener('input', manualInputHandler);
  //   }
  // }

  // async stopSpeechRecognition() {
  //   try {
  //     this.isListening = false;
  //     await SpeechRecognition.stop();
  //   } catch (error) {
  //     console.error('Error stopping speech recognition:', error);
  //   }
  // }

  // speakText() {
  //   TextToSpeech.speak({
  //     text: this.myText || 'Say something to fill the input field.',
  //     rate: 1.0,
  //   pitch: 1.0,
  //   volume: 1.0,
  //   category: 'ambient',
  //   queueStrategy: 1
  //   }).catch(error => console.error('Error with text-to-speech:', error));
  // }



  async setMultiTenantDBName() {
    let dbName: any = await this.lhStorage.get("dbName");
    let appData = await this.lhStorage.get("appData")
    if (appData == undefined) {
      return;
    }
    let userInfo = appData?.userInfo?.email;
   // ("userInfo :::::", userInfo);
    if (appData?.userInfo && dbName == undefined || dbName == null) {
      let domainName = userInfo?.split("@")[1];
      await this.tenantService.createFireStoreInstance(domainName);
    }
  }
  async checkPushNotificationPermission() {
    const alert = await this.alertController.create({
      header: this.translate.instant('PUSH_NOTIFICATION_HEADER'),
      message: this.translate.instant('PUSH_NOTIFICATION_MESSAGE'),
      buttons: [
        {
          text: this.translate.instant('APP_NO'),
          role: 'cancel',
          handler: () => {
           // console.log('User declined permission.');
          },
        },
        {
          text: this.translate.instant('APP_YES'),
          handler: async () => {
            // Redirect to app settings
            this.openNotificationDetails();
          },
        },
      ],
    });

    await alert.present();
    return;
  }
  openNotificationDetails(app = false) {
    if (Capacitor.isNativePlatform()) {
      //AndroidSettings.
      NativeSettings.open({
        optionAndroid: app ? AndroidSettings.ApplicationDetails : AndroidSettings.AppNotification,
        optionIOS: app ? IOSSettings.App : IOSSettings.Notifications
      });
    }
  }

  async setupKeyboardListeners() {
    this.keyboardWillShowListener = await Keyboard.addListener('keyboardWillShow', (info) => {
      document.body.style.setProperty('--keyboard-height', `${info.keyboardHeight}px`);
      document.body.classList.add('keyboard-is-open-custom');
    });

    this.keyboardWillHideListener = await Keyboard.addListener('keyboardWillHide', () => {
      document.body.classList.remove('keyboard-is-open-custom');
      document.body.style.removeProperty('--keyboard-height');
    });
  }

  ngOnDestroy() {
    this.keyboardWillShowListener?.remove();
    this.keyboardWillHideListener?.remove();
  }

  /**
   * Handle bog page event
   * This method is called when 'bogPageEvent' is published
   * @param value - The value passed from the event
   */
  async handleBogPageEvent(value: any) {
  //  console.log('Bog page event received with value:', value);

    // Extract tourInfo from the event payload, or use the value directly if it's already the tour object
    // The event publishes: { source: 'bog-tour-page', tourInfo: this.appService?.currentTour }
    // We need to extract tourInfo which contains currentBogTourInfo
    const tourInfo = value?.tourInfo || value;

    // Set currentTour to the full tour object (which has currentBogTourInfo property)
    // The template checks: this.appService.currentTour.currentBogTourInfo
    this.currentTour = tourInfo;

    // Trigger change detection to update the UI
    this.ngZone.run(() => {
      this.detectChanges.detectChanges();
    });
  }

}
